const PUBLIC_PATH = process.env.VUE_APP_PUBLIC_PATH || '/'
const SHOPPING_PRO_ID = '90301917'
const shoppingProNames = ['购物达人', '头像框-购物达人', '購物達人', '頭像框-購物達人', '限定头像框-[购物达人]', '限定頭像框-[購物達人]']

// 正式 ID 发布前，商品和历史记录使用 0；只归一化展示，不修改购买参数。
const normalizePropId = (propId) => {
  const id = String(propId ?? '')
  return id === '0' ? SHOPPING_PRO_ID : id
}

export const getPropIcon = (propId) => {
  const id = normalizePropId(propId)
  return id ? `${PUBLIC_PATH}imgs/props/${id}.png` : ''
}

/**
 * 优先读 i18n props.{propId}；缺 key 时回退服务端 propName / propId
 */
export const getPropName = (t, prop) => {
  const propId = normalizePropId(prop?.propId ?? prop?.id)
  const fallback = prop?.propName || propId
  // 兼容缺少 ID 的新旧快照，统一读取当前语言的正式道具名称。
  const nameId = shoppingProNames.includes(prop?.propName) ? SHOPPING_PRO_ID : propId
  if (!nameId || typeof t !== 'function') return fallback
  const key = `props.${nameId}`
  const name = t(key)
  if (!name || name === key) return fallback
  return name
}

export const formatPropText = (t, prop) => {
  const name = getPropName(t, prop)
  const count = Number(prop?.propCount ?? prop?.count ?? 0)
  if (!name) return '—'
  return count > 0 ? `${name}*${count}` : name
}

/**
 * 记录接口的 propSnapshot 统一为 [{propId, propName, propCount}] JSON 字符串
 */
export const parsePropSnapshot = (snapshot) => {
  try {
    const list = typeof snapshot === 'string' ? JSON.parse(snapshot) : snapshot
    return Array.isArray(list) ? list : []
  } catch (e) {
    return []
  }
}
